import { flattenApiMessage } from './apiErrorMessage';

type HttpErrorKeyOptions = {
	serverUnavailableKey: string;
	authKey: string;
	networkKey: string;
	clientErrorKey: string;
	fallbackKey: string;
};

/**
 * Maps transport / HTTP failures to translation keys so UI surfaces consistent messages.
 */
export const getUserFacingHttpErrorKey = (error: any, options: HttpErrorKeyOptions): string => {
	// Flattened first: a validation 400 answers with `message` as an array of objects, which
	// has no `.match` and would throw here instead of mapping to a key.
	const message =
		flattenApiMessage(error?.response?.data?.message) ||
		flattenApiMessage(error?.response?.data?.error) ||
		flattenApiMessage(error?.message);
	const matchedStatus = Number(message.match(/^Request failed with status code (\d+)$/)?.[1]);
	const resolvedStatus = error?.response?.status || matchedStatus;

	if (!error?.response && error?.request) return options.networkKey;

	if (resolvedStatus >= 500) return options.serverUnavailableKey;

	if (resolvedStatus === 401 || resolvedStatus === 403) return options.authKey;

	if (resolvedStatus === 400 || resolvedStatus === 409 || resolvedStatus === 422) {
		return options.clientErrorKey;
	}

	return message || options.fallbackKey;
};
